
import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BucketFormFields } from "../forms/BucketFormFields";
import { BucketFormData } from "../forms/BucketFormData";

interface StandardBucket {
  name: string;
  defaultAllocation: number;
}

interface AddBucketDialogProps {
  isOpen: boolean;
  onClose: () => void;
  formData: BucketFormData;
  standardBuckets: StandardBucket[];
  existingBuckets: any[];
  totalBudget: number;
  remainingBudget: number;
  onFormChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onBucketSelect: (value: string) => void;
  onAllocationSliderChange: (value: number[]) => void;
  onBudgetChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAdd: () => Promise<void>;
}

export const AddBucketDialog: React.FC<AddBucketDialogProps> = ({
  isOpen,
  onClose,
  formData,
  standardBuckets,
  existingBuckets,
  totalBudget,
  remainingBudget,
  onFormChange,
  onBucketSelect,
  onAllocationSliderChange,
  onBudgetChange,
  onAdd
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px] text-black">
        <DialogHeader>
          <DialogTitle>Add New Budget Bucket</DialogTitle>
          <DialogDescription>
            Create a new major budget category
          </DialogDescription>
        </DialogHeader>
        
        <BucketFormFields
          formData={formData}
          standardBuckets={standardBuckets}
          existingBuckets={existingBuckets}
          totalBudget={totalBudget}
          remainingBudget={remainingBudget}
          onFormChange={onFormChange}
          onBucketSelect={onBucketSelect}
          onAllocationSliderChange={onAllocationSliderChange}
          onBudgetChange={onBudgetChange}
        />
        
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onAdd}>
            Add Budget Bucket
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
